<template>
    <div>
        <h1 class="h3 mb-3 text-gray-800">
            {{ $t("Nova Referência/Contrarreferência") }}
        </h1>
        <form @submit.prevent="submit" ref="addItem">
            <!--Bloco Responsável Familiar-->
            <div class="row">
                <form-select
                    v-model="referenciamento.tipo"
                    label="Tipo"
                    grid="12"
                    :itens="$root.arrays.tipo_referencia_contrareferencia"
                    :required="true"
                    ajuda="A função de referência e contrarreferência se materializa quando a equipe do SUAS identifica demandas do usuário que extrapolam o âmbito de atuação da Unidade em razão da proteção em que está inserida. No caso a referência sempre acontece da Proteção Social Básica para a proteção Social Especial, e a contrarreferência será da Proteção Social Especial para a Proteção Social Básica, devendo ser compartilhado a responsabilidade no atendimento da família tanto nas suas vulnerabilidades, quanto na violação de direitos."
                />
                <form-select
                    v-model="referenciamento.pessoas"
                    :multiple="true"
                    label="Usuário(s)"
                    :itens="pessoas"
                    :required="true"
                    grid="12"
                />
                <form-select
                    v-model="referenciamento.unidade_destino_id"
                    label="Unidade de Intervenção"
                    grid="6"
                    :itens="unidades"
                    :required="true"
                    :disabled="disabled"
                    :loading="loadingUnidade"
                    @input="getTecnicos(referenciamento.unidade_destino_id)"
                />
                <!-- referenciamento.unidade_destino_id ? false : true -->
                <form-select
                    :disabled="loadUser"
                    v-model="referenciamento.user_destino_id"
                    label="Técnico na Unidade de Intervenção"
                    grid="6"
                    :loading="loadingDestino"
                    :itens="tecnicos"
                />
                <form-textarea-editor
                    v-model="referenciamento.situacao_identificada"
                    grid="12"
                    label="Situação Identificada"
                    :required="true"
                />
                <!--
        <form-toggle
          grid="12"
          mt="0"
          v-model="campoExtra"
          label="O grupo familiar necessita de intervenção de outra Unidade da Rede Socioassistencial?"
        />
        <form-select
          v-if="campoExtra"
          v-model="referenciamento.outra_unidade_id"
          label="Qual Unidade?"
          grid="12"
          :itens="unidades"
          :required="true"
        /> -->
                <form-file
                    @submit="submitFile"
                    multiple
                    btn-text="Iniciar"
                    :progress="progressCompleted"
                />
            </div>
            <div class="row pt-4 px-0 d-flex justify-content-end">
                <form-toggle
                    grid="9"
                    class="d-flex justify-content-end"
                    mt="0"
                    v-model="referenciamento.privado"
                    label="Sigilo?"
                />
                <div class="col-auto px-2 text-right">
                    <a class="btn btn-default" @click="$emit('voltar')">
                        <i class="mdi mdi-arrow-left" />
                    </a>
                    <button
                        class="btn btn-success btn-submit"
                        data-style="zoom-in"
                        type="submit"
                    >
                        <i class="mdi mdi-content-save" />
                        {{ $t("Salvar") }}
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
export default {
    props: ["familia"],
    name: "Add",
    data() {
        return {
            referenciamento: {privado:false},
            tecnicos: [],
            unidades: [],
            files: [],
            loadUser: true,
            progressCompleted: 0,
            campoExtra: false,
            disabled: true,
            loadingUnidade: false,
            loadingDestino: false,
        };
    },
    computed: {
        pessoas() {
            // this.getTecnicos();
            let pessoas = this.familia.familiares ?? [];
            pessoas = pessoas.filter((elem) => {
                return elem.estado_cadastral_cadunico <= 3;
            });
            const map = pessoas.map((elem) => ({
                id: elem.id,
                value:
                    elem.posicao_familiar == 1
                        ? "<b>RF - </b> " +
                          elem.nome_completo +
                          " <b>" +
                          elem.idade +
                          " ano(s)</b>"
                        : elem.nome_completo +
                          " <b>" +
                          elem.idade +
                          " ano(s)</b>",
            }));
            return map;
        },
    },
    watch: {
        "referenciamento.tipo": function (val) {
            this.referenciamento.unidade_destino_id = "";
            this.referenciamento.user_destino_id = "";
            this.getUnidades(val);
        },
    },
    mounted(){
        // this.privateFromOsasco()
    },
    methods: {
        // privateFromOsasco() {
        //   const role_name = this.$store.state.user.role_details.name;
        
        //     if (window.location.hostname == "osascosp.suasfacil.com.br" || window.location.hostname == 'sandbox.suasfacil.com.br' && role_name == 'Técnico(a) de Nível Superior') {
        //         this.referenciamento.privado =  1;
        //     } else {
        //         this.referenciamento.privado =  2;
        //     }
        // },
        submitFile(files) {
            this.files = files;
        },
        getTecnicos(unidade_id) {
            this.loadUser = true;
            this.loadingDestino = true;
            axios
                .get(
                    `api/dashboard/tecnicos/get/externos/${unidade_id}/superior`
                )
                .then((response) => {
                    this.tecnicos = response.data;
                })
                .finally(() => {
                    this.loadUser = false;
                    this.loadingDestino = false;
                });
        },
        getUnidades(tipo) {
            this.loadingUnidade = true;
            tipo == 1 ? (tipo = "referencia") : (tipo = "contrarreferencia");
            axios
                .get(`api/dashboard/unidades/get/externas/${tipo}`)
                .then((response) => {
                    this.unidades = response.data;
                    this.disabled = false;
                })
                .finally(() => (this.loadingUnidade = false));
        },
        submit() {
            this.referenciamento.familia_id = this.$route.query.familia_id;
            if (this.referenciamento.data) {
                this.referenciamento.data = moment(
                    this.referenciamento.data,
                    "YYYY-MM-DD"
                ).format("DD/MM/YYYY");
            }
            let formData = new FormData();
            if (this.files.length > 0 && this.files.length != undefined) {
                for (const i of Object.keys(this.files)) {
                    formData.append("anexos[]", this.files[i]);
                }
            } else {
                formData.append("anexos", this.files);
            }
            for (var key in this.referenciamento) {
                formData.append(key, this.referenciamento[key]);
            }
            let ladda = Ladda.create(document.querySelector(".btn-submit"));
            ladda.start();
            axios
                .post(`api/dashboard/referenciamentos`, formData, {
                    header: { "Content-Type": "multipart/form-data" },
                    onUploadProgress: (event) => {
                        let progress = Math.round(
                            (event.loaded * 100) / event.total
                        );
                        this.progressCompleted = progress;
                    },
                })
                .then((response) => {
                    ladda.stop();
                    this.$snack.success({
                        button: false,
                        text: response.data.data.message,
                    });
                    this.$emit("voltar");
                    this.$emit("reload");
                })
                .finally(() => {
                    this.progressCompleted = 0;
                    this.files = [];
                });
        },
    },
};
</script>
